import { LoadingScreen } from "@/components/elements/Loading/Loading";
import { verifyCenterOAuthToken } from "@/features/auth/services/centerOAuthApi";
import { AppRoutes } from "@/routes/config";
import { logout } from "@/utils/api";
import { POST_LOGIN_REDIRECT_KEY } from "@/utils/center";
import { showError } from "@/utils/error";
import { setToken } from "@/utils/token";
import Cookies from "js-cookie";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

const getSafeRedirectPath = (raw: string | null, fallback: string): string => {
  if (raw && raw.startsWith("/") && !raw.startsWith("//")) {
    return raw;
  }
  return fallback;
};

const AuthCallback = () => {
  const [searchParams] = useSearchParams();

  const token = searchParams.get("token");
  const redirectUrl = getSafeRedirectPath(searchParams.get("redirectUrl") || sessionStorage.getItem(POST_LOGIN_REDIRECT_KEY), AppRoutes.home);

  useEffect(() => {
    const handleCallback = async () => {
      if (!token) {
        window.location.replace(AppRoutes.login);
        return;
      }

      try {
        const data = await verifyCenterOAuthToken(token);
        logout();
        setToken(data.accessToken, data.refreshToken);
        Cookies.set("x-auth-source", "center");
        if (data.email) Cookies.set("email", data.email);
        if (data.ownerId != null) Cookies.set("ownerId", data.ownerId.toString());
        if (data.userId != null) Cookies.set("userId", data.userId.toString());
        if (data.isUser != null) Cookies.set("isUser", data.isUser.toString());

        sessionStorage.removeItem(POST_LOGIN_REDIRECT_KEY);
        window.location.replace(redirectUrl);
      } catch (err) {
        showError(err);
        window.location.replace(AppRoutes.login);
      }
    };

    handleCallback();
  }, [token, redirectUrl]);

  return <LoadingScreen />;
};

export default AuthCallback;
